export default "__VITE_ASSET__Uwu1safg__"